import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69fdfb52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Result" }
const _hoisted_2 = { class: "result" }
const _hoisted_3 = { class: "result-header" }
const _hoisted_4 = { class: "result-header-title-text" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "desc" }, "感谢你的支持", -1))
const _hoisted_7 = { class: "more" }
const _hoisted_8 = { class: "release" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "lable" }
const _hoisted_11 = { class: "tips" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("继续发布")
const _hoisted_13 = { class: "actions" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("返回上一页")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_VanButton = _resolveComponent("VanButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_VanIcon, {
          name: "passed",
          size: "64",
          color: "#fff"
        }),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString($setup.title), 1),
          _hoisted_6
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, "发布" + _toDisplayString($setup.type[_ctx.$route.query.type].title), 1),
            _createElementVNode("div", _hoisted_11, "获得更多" + _toDisplayString($setup.tips) + "，快速做成生意", 1)
          ]),
          _createVNode(_component_VanButton, {
            type: "success",
            size: "small",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.router.back())),
            color: "#FFC000"
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_VanButton, {
          type: "success",
          block: "",
          onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.back())),
          color: "#FFC000"
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        })
      ])
    ])
  ]))
}